var _rect, _g, _rect2, _rect3, _rect4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMascotte3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 586,
    height: 344,
    viewBox: "0 0 586 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 586,
    height: 344
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 586,
    height: 344,
    rx: 15,
    fill: "#FFD77C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M-1.67502 192.225C81.1081 187.996 107.535 245.143 238.128 221.4C342.261 202.47 387.091 273.147 400.059 317.055C406.248 338.034 407.82 420.029 350.677 421.2C156.753 425.233 1.37038 637.751 -92.1208 451.904C-130.041 376.511 -189.607 201.852 -1.67502 192.225Z",
    fill: "white",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M461.325 -201.775C544.108 -206.004 570.535 -148.857 701.128 -172.6C805.261 -191.53 850.091 -120.853 863.059 -76.9446C869.248 -55.966 870.82 26.0293 813.677 27.2002C619.752 31.2333 464.37 243.751 370.879 57.9037C332.959 -17.4891 273.393 -192.148 461.325 -201.775Z",
    fill: "white",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.4021 312.028C76.187 344.213 104.899 380.222 140.604 380.464C176.322 380.706 205.518 345.098 205.733 312.901C205.949 280.716 177.116 264.127 141.397 263.885C105.679 263.644 76.6173 279.83 76.3887 312.015L76.4021 312.028Z",
    fill: "url(#paint0_linear_0_1)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183.538 280.043L183.526 280.049C176.813 283.391 174.085 291.531 177.434 298.23L196.678 336.735C200.027 343.435 208.183 346.157 214.896 342.815L214.908 342.809C221.62 339.467 224.348 331.327 220.999 324.628L201.755 286.123C198.407 279.424 190.25 276.702 183.538 280.043Z",
    fill: "url(#paint1_linear_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4849 183.988L72.6095 173.358C65.6164 170.11 57.3861 170.996 51.2403 175.667C40.8852 183.545 33.6904 194.859 30.9739 207.569C26.4553 228.627 38.0207 249.833 58.193 257.484L80.6246 265.993L95.4849 184.001V183.988Z",
    fill: "#9E83FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8219 196.47L73.8061 187.625C67.9831 184.914 61.1379 185.652 56.0411 189.544C47.4342 196.094 41.4498 205.502 39.1905 216.065C35.4384 233.58 45.0405 251.202 61.8238 257.564L80.4764 264.637L92.8353 196.47H92.8219Z",
    fill: "url(#paint2_linear_0_1)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.0682 233.58C78.1102 233.003 84.0139 240.962 80.3291 249.538L78.2312 254.41C76.2543 259.013 72.2468 268.596 75.9854 271.925L87.7929 284.219C100.058 301.922 88.6939 312.739 83.9198 313.33C68.6561 315.182 50.7028 282.179 50.7028 282.179C45.2562 272.086 49.8824 263.456 52.5586 256.745C56.3914 247.082 63.2634 234.09 70.0682 233.593V233.58Z",
    fill: "url(#paint3_linear_0_1)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M169.934 175.72L189.904 160.326C196.01 155.615 204.24 154.675 211.26 157.883C223.094 163.292 232.602 172.754 238.062 184.551C247.113 204.106 240.496 227.326 222.503 239.217L202.492 252.437L169.934 175.72Z",
    fill: "#9E83FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.286 187.316L191.895 174.512C196.978 170.593 203.81 169.815 209.646 172.485C219.49 176.982 227.398 184.847 231.93 194.658C239.447 210.911 233.961 230.224 218.993 240.103L202.357 251.095L175.286 187.316Z",
    fill: "url(#paint4_linear_0_1)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.247 234.962C215.645 274.381 185.601 295.614 146.104 300.003C106.607 304.391 72.6231 290.272 68.2256 250.853C63.828 211.435 103.191 164.205 130.625 161.158C158.06 158.111 206.85 195.544 211.247 234.962Z",
    fill: "url(#paint5_linear_0_1)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.98 167.936C122.825 172.07 124.506 186.108 124.506 186.108C124.708 186.578 125.367 186.337 125.582 186.175C126.483 185.451 128.419 182.458 128.419 182.458C128.661 182.028 129.267 182.055 129.482 182.498C129.482 182.498 131.539 187.424 132.373 191.974C132.427 192.269 133.288 192.014 133.503 191.812C135.466 190.041 136.313 181.424 136.313 181.424C136.408 180.941 136.972 180.753 137.322 181.089C137.322 181.089 139.85 181.907 141.478 185.062C141.599 185.303 142.311 184.887 142.486 184.686C146.063 180.592 146.964 166.473 143.495 162.5C138.559 156.85 109.632 164.124 115.993 167.963L115.98 167.936Z",
    fill: "#8058EA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M168.885 267.241C171.4 257.604 181.271 251.833 190.926 254.343",
    stroke: "#806CFF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.231 258.335C123.672 257.065 131.616 244.09 129.973 229.356C128.33 214.622 117.723 203.708 106.281 204.979C94.8397 206.25 86.8963 219.224 88.5392 233.958C90.1822 248.692 100.789 259.606 112.231 258.335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.444 222.977C187.995 227.983 185.897 235.66 185.897 235.66L150.986 240.224C150.986 240.224 146.642 232.788 146.01 227.581C144.208 212.871 152.304 199.879 163.748 198.604C175.193 197.329 185.803 208.24 187.444 222.977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.966 229.352C130.518 234.358 128.42 242.035 128.42 242.035L93.5083 246.599C93.5083 246.599 89.1646 239.163 88.5325 233.956C86.7304 219.246 94.8263 206.254 106.271 204.979C117.715 203.704 128.326 214.615 129.966 229.352Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.348 209.905C177.324 205.125 171.801 202.888 167.012 204.908C162.223 206.928 159.982 212.44 162.005 217.219L164.623 223.401C166.647 228.18 172.17 230.417 176.959 228.397C181.748 226.377 183.989 220.865 181.965 216.086L179.348 209.905Z",
    fill: "#122431"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.032 215.166C174.632 215.166 176.739 213.062 176.739 210.468C176.739 207.874 174.632 205.771 172.032 205.771C169.433 205.771 167.325 207.874 167.325 210.468C167.325 213.062 169.433 215.166 172.032 215.166Z",
    fill: "#FEFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.756 216.377C119.732 211.598 114.209 209.361 109.42 211.381C104.631 213.401 102.39 218.913 104.414 223.692L107.031 229.873C109.055 234.653 114.578 236.89 119.367 234.87C124.156 232.85 126.397 227.338 124.374 222.559L121.756 216.377Z",
    fill: "#122431"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.433 221.622C117.033 221.622 119.14 219.518 119.14 216.924C119.14 214.33 117.033 212.227 114.433 212.227C111.834 212.227 109.727 214.33 109.727 216.924C109.727 219.518 111.834 221.622 114.433 221.622Z",
    fill: "#FEFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.3882 304.714L90.3344 301.291C90.2941 298.701 92.4862 296.473 95.0682 296.795C95.243 296.822 102.734 301.6 106.553 302.137C110.762 302.741 116.774 299.748 119.194 291.937C122.395 281.602 117.473 270.851 119.853 264.127C124.036 252.33 134.619 248.035 144.786 250.169C154.966 252.303 162.511 262.557 161.96 272.985C161.408 283.414 149.385 302.043 142.043 309.358C133.019 318.35 119.598 319.37 112.914 318.39C102.236 316.833 92.3517 310.807 92.3517 310.807C89.1241 309.935 89.3258 306.942 90.4017 304.714H90.3882Z",
    fill: "url(#paint6_linear_0_1)"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 29,
    width: 294,
    height: 285,
    rx: 30,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 109,
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 59,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 68.3887,
    y: 258.883,
    width: 145.346,
    height: 132.583,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_0_1",
    x: 36.168,
    y: 223.55,
    width: 65.1338,
    height: 99.855,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.262745 0 0 0 0 0 0 0 0 0 0.447059 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_0_1",
    x: 59.8867,
    y: 155.984,
    width: 159.788,
    height: 155.788,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_0_1",
    x: 113.084,
    y: 159.426,
    width: 34.5967,
    height: 35.6816,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_0_1",
    x: 81.6934,
    y: 244.643,
    width: 88.2949,
    height: 85.0483,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 141.074,
    y1: 263.898,
    x2: 141.072,
    y2: 380.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#AD95FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 188.974,
    y1: 278.042,
    x2: 186.555,
    y2: 342.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 95.7525,
    y1: 222.836,
    x2: 38.764,
    y2: 229.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1",
    x1: 65.9164,
    y1: 310.271,
    x2: 80.3947,
    y2: 235.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_1",
    x1: 178.222,
    y1: 213.655,
    x2: 235.224,
    y2: 207.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_1",
    x1: 146.107,
    y1: 300.003,
    x2: 130.687,
    y2: 161.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_0_1",
    x1: 145.742,
    y1: 250.072,
    x2: 110.67,
    y2: 320.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A990FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#BBA6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#C5B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMascotte3);
export default __webpack_public_path__ + "static/media/mascotte3.07b7c637961db7407ffc28c70957c1cc.svg";
export { ForwardRef as ReactComponent };